module.exports = __webpack_public_path__ + "static/media/magazineTupp_03_thumb.61fae49c.png";